//@ts-strict-ignore
function isFunction(functionToCheck: any): functionToCheck is Function {
  const getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

export const isReactMemoOrLazy = (element) => {
  return (
    element &&
    element.$$typeof &&
    (element.$$typeof.toString() === 'Symbol(react.memo)' ||
      element.$$typeof.toString() === 'Symbol(react.lazy)' ||
      element.$$typeof.toString() === 'Symbol(react.forward_ref)')
  );
};

export default isFunction;
